import { IconExclamationTriangleOutline, IconFileUp } from '@iwoca/icons';

import styles from './FileStatusSections.module.css';
import { TFile } from '../../../../../hooks/useFileUploadReducer';
import UploadedFiles from '../../../UploadedFiles/UploadedFiles';

type TFilesByStatus = {
  loading: TFile[];
  uploaded: TFile[];
  rejected: TFile[];
};

const groupFilesByStatus = (files: TFile[]): TFilesByStatus => {
  return files.reduce<TFilesByStatus>(
    (acc, file) => {
      if (file.status === 'loading') {
        acc.loading.push(file);
      } else if (file.status === 'error' || file.status === 'rejected') {
        acc.rejected.push(file);
      } else {
        acc.uploaded.push(file);
      }
      return acc;
    },
    { loading: [], uploaded: [], rejected: [] },
  );
};

type TProps = {
  files: TFile[];
  removeFile: (id: string) => void;
};

const FileStatusSections = ({ files, removeFile }: TProps) => {
  const groupedFiles = groupFilesByStatus(files);
  const hasLoadingFiles = groupedFiles.loading.length > 0;
  const hasUploadedFiles = groupedFiles.uploaded.length > 0;
  const hasRejectedFiles = groupedFiles.rejected.length > 0;

  if (!hasLoadingFiles && !hasUploadedFiles && !hasRejectedFiles) {
    return null;
  }

  const uploadSectionFiles = hasLoadingFiles
    ? [...groupedFiles.uploaded, ...groupedFiles.loading]
    : groupedFiles.uploaded;

  const showUploadSection = hasLoadingFiles || hasUploadedFiles;

  return (
    <>
      {showUploadSection && (
        <div className={styles.uploadedSection}>
          <div className={styles.filesList}>
            <UploadedFiles files={uploadSectionFiles} removeFile={removeFile} />
          </div>
          <div className={styles.sectionLabel}>
            <IconFileUp className={styles.uploadedIcon} />
            <p>
              {hasLoadingFiles ? 'Uploading documents' : 'Documents uploaded'}
            </p>
          </div>
        </div>
      )}

      {hasRejectedFiles && (
        <div className={styles.rejectedSection}>
          <div className={styles.filesList}>
            <UploadedFiles
              files={groupedFiles.rejected}
              removeFile={removeFile}
            />
          </div>
          <div className={styles.sectionLabelRejected}>
            <IconExclamationTriangleOutline className={styles.rejectedIcon} />
            <p>Documents rejected</p>
          </div>
        </div>
      )}
    </>
  );
};

export default FileStatusSections;
